import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { addCardToQueue, removeCardFromQueue, addCardToQueueDisplay, removeCardFromQueueDisplay } from '../../../../store/card/card.action';

// styles
import {
    QueueCardContainer,
    CardHeader,
    CardNumber,
    AttributesContainer,
    CardContent,
    RightSection,
    RightTop,
    RightBottom,
    RightOddsSection,
    QtyContent,
    QtyBtns,
    QtyButton
} from './QueueCard.styles';

// assets
import addIcon from '../../../../assets/system/icons/add-icon.png';
import minusIcon from '../../../../assets/system/icons/minus-icon.png';
import CardAttribute from '../../../card-attribute/CardAttribute';
import {
    findParallelDefinition,
    getDefinedOddsEntries,
    formatOddsForDisplay,
    queueParallelAttributeText,
} from '../../utils/queueParallelOdds.js';

export default function QueueCard({ card, index, parallel, selectedOddsProducts = null, parallelData = [] }) {
    const dispatch = useDispatch();

    const showOdds = selectedOddsProducts && selectedOddsProducts.length > 0;

    const oddsPairs = useMemo(() => {
        if (!showOdds || !parallelData?.length) return [];
        const def = findParallelDefinition(parallelData, parallel);
        const allPairs = getDefinedOddsEntries(def?.odds);
        if (selectedOddsProducts.includes('all')) return allPairs;
        return allPairs.filter(([product]) => selectedOddsProducts.includes(product));
    }, [showOdds, selectedOddsProducts, parallelData, parallel]);

    const handleRemoveCard = () => {
        dispatch(removeCardFromQueueDisplay(index));
        dispatch(removeCardFromQueue(card, parallel.cardParallelName));
    };

    const handleQtyChangeFromQueue = (inc) => {
        // Don't allow quantity changes for numbered cards (cards with cardSupply)
        if (parallel.cardSupply != null) {
            return;
        }
        dispatch(
            addCardToQueue(
                card.sport,
                card.year,
                card.manufacturer,
                card.series,
                card.cardType,
                card.cardTypeCategory,
                card.card,
                inc
            )
        );
        dispatch(
            addCardToQueueDisplay(
                card.sport,
                card.year,
                card.manufacturer,
                card.series,
                card.cardType,
                card.cardTypeCategory,
                card.card,
                inc
            )
        );
    };

    return (
        <QueueCardContainer className='dropshadow'>
            <CardContent>
                <CardNumber>
                    <h4>{card.card.cardNumber}</h4>
                </CardNumber>

                <RightSection>
                    <RightTop>
                        <CardHeader>
                            {card.card.name.map((name, index) => (
                                <span key={index}>
                                    <h3>{name}</h3>
                                    {index < card.card.name.length - 1 && ' • '}
                                </span>
                            ))}
                        </CardHeader>
                        {showOdds && oddsPairs.length > 0 && (
                            <RightOddsSection>
                                {oddsPairs.map(([product, value]) => (
                                    <CardAttribute
                                        key={product}
                                        text={`${product}: ${formatOddsForDisplay(value)}`}
                                    />
                                ))}
                            </RightOddsSection>
                        )}
                    </RightTop>

                    <RightBottom>
                        {(card.card.cardAttributes?.length > 0 || card.card.collectedCards?.length > 0) &&
                            <AttributesContainer>
                                {card.card.cardAttributes?.length > 0 &&
                                    card.card.cardAttributes.map(attribute => (
                                        <CardAttribute key={attribute} text={attribute} />
                                    ))
                                }
                                {card.card.cardAttributes?.length > 0 && card.card.collectedCards?.length > 0 &&
                                    <h4>•</h4>
                                }
                                {card.card.collectedCards.map((collectedParallel) => {
                                    const borderColor = collectedParallel.cardColor ? collectedParallel.cardColor : '#FFFFFF';
                                    return (
                                        <CardAttribute
                                            key={collectedParallel.cardParallelName}
                                            color={borderColor}
                                            text={queueParallelAttributeText(collectedParallel)}
                                        />
                                    );
                                })}
                            </AttributesContainer>
                        }
                        <QtyContent>
                            <QtyBtns>
                                <QtyButton $isActive={parallel.cardSupply == null} onClick={() => handleQtyChangeFromQueue(-1)}>
                                    <img src={minusIcon} alt='subtract from checklist button' />
                                </QtyButton>
                                <h4>{parallel.cardQty}</h4>
                                <QtyButton $isActive={parallel.cardSupply == null} onClick={() => handleQtyChangeFromQueue(1)}>
                                    <img src={addIcon} alt='add from checklist button' />
                                </QtyButton>
                            </QtyBtns>
                            <CardAttribute text="REMOVE" onClick={() => handleRemoveCard(index)} />
                        </QtyContent>
                    </RightBottom>
                </RightSection>
            </CardContent>
        </QueueCardContainer>
    );
}